/**
 * Whether a keydown target is consuming keystrokes as text, so global
 * single-key shortcuts must not fire. Beyond text fields, this covers
 * typeahead widgets (e.g. Radix Select renders a `button[role="combobox"]`
 * trigger and a portaled list of `div[role="option"]`s, never an input).
 */
export function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return (
    target.tagName === "INPUT" ||
    target.tagName === "TEXTAREA" ||
    target.tagName === "SELECT" ||
    target.isContentEditable ||
    target.closest(
      '[role="combobox"], [role="listbox"], [role="option"], [role="menu"], [role="menuitem"]',
    ) !== null
  );
}
